import { render, staticRenderFns } from "./FormElementStyle.vue?vue&type=template&id=d72c6894&scoped=true&"
var script = {}
import style0 from "./FormElementStyle.vue?vue&type=style&index=0&id=d72c6894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72c6894",
  null
  
)

export default component.exports